import { render } from "./FailureAlart.vue?vue&type=template&id=ba9d1986&scoped=true"
import script from "./FailureAlart.vue?vue&type=script&lang=js"
export * from "./FailureAlart.vue?vue&type=script&lang=js"

import "./FailureAlart.vue?vue&type=style&index=0&id=ba9d1986&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ba9d1986"

export default script